const safeParseFloat = (value) => {
  const parce = parseFloat(value);
  return isNaN(parce) ? 0 : parce;
};

export const getAmoutFixed = (value) => safeParseFloat(value).toFixed(2);
